import { request } from "../utils/request";
import { getNewEndpoint } from "../config/newEndpoint";

async function get(params) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: NEW_ENDPOINT.FLAVORS,
    method: "get",
    params,
  });
}

export default {
  get,
};
